import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { palexy } from "../generated/bundle";
import * as protobuf from "protobufjs";
import * as serializer from 'proto3-json-serializer';
import protoJSON from '../generated/bundle.json';

@Injectable({
  providedIn: "root",
})
export class StoreService {
  private protoRoot = protobuf.Root.fromJSON(protoJSON as any);
  constructor(private http: HttpClient) {}

  fetchStores = (): Observable<palexy.streaming.v1.ListStoresResponse> =>
    this.http
      .get(`api/v1/stores`)
    .pipe(map(response => {
      const Type = this.protoRoot.lookupType("palexy.streaming.v1.ListStoresResponse");
      return serializer.fromProto3JSON(Type, response as any).toJSON()}))
    .pipe(map(palexy.streaming.v1.ListStoresResponse.fromObject));

  fetchCompanyStores = (
    companyId: number
  ): Observable<palexy.streaming.v1.ListStoresResponse> =>
    this.http
      .get(`api/v1/stores?companyId=${companyId}`)
      .pipe(map(response => {
        const Type = this.protoRoot.lookupType("palexy.streaming.v1.ListStoresResponse");
        return serializer.fromProto3JSON(Type, response as any).toJSON();
      }))
      .pipe(map(palexy.streaming.v1.ListStoresResponse.fromObject));

  getStore = (storeId): Observable<palexy.streaming.v1.Store> =>
    this.http
      .get(`api/v1/stores/${storeId}`)
      .pipe(map(response => {
        const Type = this.protoRoot.lookupType("palexy.streaming.v1.Store");
        return serializer.fromProto3JSON(Type, response as any).toJSON();
      }))
      .pipe(map(palexy.streaming.v1.Store.fromObject));
}
